export const CONTACT_EMAIL_ADDRESS = 'Health.HR@state.mn.us'

export const requestTypeOptions = [
        { value: '01', text: 'New Position' },
        { value: '02', text: 'Backfill' },
        { value: '03', text: 'Reallocation' },
        { value: '04', text: 'Change in Allocation, occupied position' },
        { value: '05', text: 'Conversion' },
        { value: '06', text: 'Appeal' },
        { value: '07', text: 'Work out of Class' },    
        { value: '08', text: 'Student Worker' },
    ]

export const links = {
    contractorSecurity: {
        url: '/it/security/contractors',
        text: 'Security Awareness and Contractors at MDH'
    }
}